import React from 'react';
import { FiBookOpen } from 'react-icons/fi';
import './SplashScreen.css';

const SplashScreen = () => {
    return (
        <div className="splash-screen">
            <div className="splash-content">
                <div className="splash-logo">
                    <FiBookOpen size={64} />
                    <div className="splash-ripple"></div>
                </div>
                <h1 className="splash-title">Mintra<span className="highlight">Lib</span></h1>
                <p className="splash-subtitle">Loading your workspace...</p>
            </div>
        </div>
    );
};

export default SplashScreen;
